import { tasksRepo } from '@/constants/providers';
import { ApiResponse } from '@/shared/types';
import { useMutation } from '@tanstack/react-query';

export const useEnableTask = () =>
  useMutation<ApiResponse<unknown>, unknown, number>((id) =>
    tasksRepo.enableTask(id),
  );
